export default [
    {
        component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-unidade' */ '@/views/web-service/almoxarifado/cliente/unidade/Index'),
        path: 'almoxarifado-cliente-unidade',
        redirect: 'almoxarifado-cliente-unidade/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-unidade' */'@/views/web-service/almoxarifado/cliente/unidade/List.vue'),
                name: 'web-service-almoxarifado-cliente-unidade-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-unidade' */ '@/views/web-service/almoxarifado/cliente/unidade/Form.vue'),
                name: 'web-service-almoxarifado-cliente-unidade-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-unidade' */ '@/views/web-service/almoxarifado/cliente/unidade/Form.vue'),
                name: 'web-service-almoxarifado-cliente-unidade-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]